import * as React from "react";
import C from "classnames";
export const Form = ({ children, className, onSubmit, testId, }) => {
    return (React.createElement("form", { onSubmit: onSubmit, className: C("form", className && className), "data-testid": testId }, children));
};
//# sourceMappingURL=Form.js.map